/**
 * Style a closed shadow root without an inline `<style>` element.
 *
 * CSP is enforced per document, shadow roots included: on a host page whose
 * `style-src` has no `'unsafe-inline'` (Salesforce Lightning is one), an
 * inline style node is blocked and the launcher renders bare. A constructed
 * stylesheet goes through the CSSOM, which CSP does not govern. The inline
 * element stays as the fallback for an engine without constructable
 * stylesheets, and for test stand-ins that only model `append`.
 */
// oxlint-disable-next-line typescript-eslint/prefer-readonly-parameter-types -- ShadowRoot is an external mutable DOM interface
export const attachStyles = (shadow: ShadowRoot, css: string): void => {
	if (
		typeof CSSStyleSheet === "function" &&
		"adoptedStyleSheets" in shadow &&
		"replaceSync" in CSSStyleSheet.prototype
	) {
		try {
			const sheet = new CSSStyleSheet();
			sheet.replaceSync(css);
			shadow.adoptedStyleSheets = [sheet];
			return;
		} catch {
			// Fall through to the inline element.
		}
	}
	const style = document.createElement("style");
	style.textContent = css;
	shadow.append(style);
};
